import React, { useLayoutEffect } from "react";

import "./login.css";
import { useParams } from "react-router-dom";

import { toast } from "react-toastify";

import AdminListService from "../../../services/admin-list.service";
import secureLocalStorage from "react-secure-storage";
import { bindActionCreators } from "redux";
import { useDispatch } from "react-redux";
import { actionCreaters } from "../../../Redux";

export default function VerifyUser() {
  const dispatch = useDispatch();
  const userActions = bindActionCreators(actionCreaters, dispatch);
  const { id, type } = useParams();

  const loginBrpwse = async () => {
    try {
      const response = await AdminListService.getAzureLoginUserInfo(id, type);

      if (response?.data?.data?.redirect === "add_customer") {
        if (response.status === 200) {
          await userActions.logIn(
            {
              customerAccessToken: response.data.data.access_token,
              customer_id: response.data.data.AdminId,
              customerSiteId: response.data.data.SiteId,
            },
            "customerLogin",
          );
          window.location.href = "/3in1Step";
        }
      } else if (response?.data?.data?.redirect === "searchcerti_pav") {
        if (response.status === 200) {
          await userActions.logIn(
            {
              pavlinaAccessToken: response.data.data.access_token,
              pavlina_id: response.data.data.pavlinaId,
            },
            "pavlinaLogin",
          );
          window.location.href = "/searchcerti_pav";
        }
      } else if (response?.data?.data?.redirect === "index") {
        if (response.status === 200) {
          await userActions.logIn(
            {
              adminAccessToken: response.data.data.access_token,
              admin_id: response.data.data.AdminId,
            },
            "adminLogin",
          );
          window.location.href = "/admin_dashboard";
        }
      }
    } catch (err) {
      console.log(err);

      setTimeout(() => {
        if (err?.response?.data?.redirect) {
          if (err?.response?.data?.redirect === "add_customer") {
            window.location.href = "/admin/customer";
          } else if (err?.response?.data?.redirect === "searchcerti_pav") {
            window.location.href = "/admin/pavlina";
          } else if (err?.response?.data?.redirect === "index") {
            window.location.href = "/admin/login";
          }
        } else window.location.href = "/admin/login";
      }, 2000);

      if (
        err?.response?.data?.message &&
        typeof err?.response?.data?.message === "string"
      ) {
        toast.error(err?.response?.data?.message, {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      } else {
        toast.error("Something went wrong, try again", {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      }
    }
  };
  useLayoutEffect(() => {
    if (id) {
      loginBrpwse();
    }
  }, [id]);
  return (
    <div className={`loader in with-verify`}>
      <div className="spinner-border main-spin"></div>
    </div>
  );
}
